import styled from "styled-components";
import { keyframes } from "styled-components";

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { typography } from "./variables";
// +-----------------------------------------+
// | Defines horizontal layout of components |
// +-----------------------------------------+

export const UserModalContainer = styled.div`
  .css-26l3qy-menu {
    z-index: 2 !important;
  }
  .MuiInputLabel-root {
    z-index: 0 !important;
  }
`;
export const HorizontalFlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const HorizontalLeftAlignContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
export const NoData = styled.div`
  background: rgb(254, 250, 241);
  padding: 50px 20px;
  width: 100%;
  text-align: center;
  margin: 0 auto 20px auto;
  border-radius: 10px;
  font-style: italic;
  color: #888585;
`;
export const UserDisplayButton = styled.div`
  background: #000000;
  border-radius: 2px;
  width: 100%;
  max-width: max-content;
  height: 100%;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  :hover {
    transform: scale(1.01);
  }
  button {
    color: #ffffff !important;
    border: none;
    outline: none;
    transition: all 1s;
    font: 14px/22px "Museo Sans", sans-serif;
    height: 45px;

    :focus {
      border: none;
      outline: none;
    }
    :hover {
      border: none;
      outline: none;
    }
  }
`;

export const HorizontalRightAlignContainer = styled.div`
  justify-content: flex-end;
  align-items: center;
  /* button {
    width: 100%;
    min-width: 200px;
    background: #000000;
    border-radius: 2px;
    height: 45px;
    font: 14px/22px "Museo Sans", sans-serif;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #ffffff;
    :hover {
      background: #000000;
    }
  } */
`;
const loadingAnimation = keyframes`
  0% {
    content: '';
  }
  20% {
    content: '.';
  }
  40% {
    content: '..';
  }
  60% {
    content: '...';
  }
  80% {
    content: '....';
  }
  100% {
    content: '.....';
  }
  
`;
export const LoadingPoints = styled.div`
  display: inline-block;
  font-size: 24px;
  line-height: 1;
  &:after {
    content: "";
    animation: ${loadingAnimation} 3s infinite;
  }
`;
